// src/components/LoadingSpinner/LoadingSpinner.tsx

import React from "react";
import "./LoadingSpinner.scss";

const LoadingSpinner: React.FC = () => {
    return (
        <div className="spinner-container">
            <div className="loading-spinner"></div>
        </div>
    );
};

export default LoadingSpinner;
